import React from 'react';
import RSelect from 'react-select';
import styled, { css } from 'styled-components';
import { Theme } from '../../../theme';

const SelectWrapper = styled.div<{ label?: any; disabled?: any }>`
  ${({ label, disabled }) => css`
    position: relative;
    ${
      label &&
      css`
        margin-top: 4px;
      `
    }
    ${
      disabled &&
      css`
        cursor: not-allowed;
      `
    }
  `}
`;

const Label = styled.label<{ disabled?: any }>`
  ${({ theme, disabled }) => css`
    font-size: 1rem;
    margin: 0 0 0 4px;
    color: ${theme.colors.black};
    ${
      disabled &&
      css`
        color: ${theme.colors.grey};
      `
    }
  `}
`;

const customStyles = {
  control: (provided: any, state: any) => {
    const focusedColor = state.isFocused && Theme.colors.primary;
    return {
      ...provided,
      minHeight: 48,
      borderRadius: 8,
      outline: 'none',
      borderColor: focusedColor || Theme.colors.greyLighter,
      ':hover': {
        borderColor: focusedColor || Theme.colors.grey,
      },
      boxShadow: 'none',
    };
  },
  container: (provided: any) => ({
    ...provided,
    outline: 'none',
  }),
  indicatorSeparator: () => {},
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 1100,
  }),
};

interface SelectProps {
  label?: string;
  name?: string;
  [key: string]: any;
}

const Select = ({ label, name, ...selectProps }: SelectProps) => {
  return (
    <>
      {label && (
        <Label htmlFor={name} disabled={selectProps.disabled}>
          {label}
        </Label>
      )}
      <SelectWrapper label={label} disabled={selectProps.disabled}>
        <RSelect
          menuPortalTarget={document.querySelector('body')}
          styles={customStyles as any}
          {...selectProps}
        />
      </SelectWrapper>
    </>
  );
};

export default Select;
